import { defineStore } from 'pinia'

// rename to account store
export const useContractStore = defineStore('contract', {
  state: () => ({
    currentContract: null,
  }),
  actions: {
  },
  getters: {
  }
});